import { AbstractControl, Validators } from '@angular/forms';
import { CustomValidators } from '@narik/custom-validators';
import { BaseVariableControl } from './_base-control';



export class InputControl extends BaseVariableControl {
    messages: any = {};

    setValidators(formControl: AbstractControl) {

        const validators = this.variable.displayMetadata.templateData.validators?.map(element => {

            var type = <string> element.typeId;

            if (type.includes("RegularExpressionAttribute"))
            {
                this.messages.pattern = element.errorMessage;

                return Validators.pattern(element.pattern);
            }
            else if (type.includes("EmailAddressAttribute"))
            {
                return Validators.compose([CustomValidators.email]);
            }
            else if (type.includes("PhoneAttribute"))
            {
                this.messages.pattern = element.errorMessage;

                return Validators.pattern("^[0-9]*$");
            }
            else if (type.includes("RequiredAttribute"))
            {
                return Validators.required;
            }
            else if (type.includes("RangeAttribute"))
            {
                return Validators.compose([CustomValidators.range([element.minimum, element.maximum])]);
            }
            else if (type.includes("StringLengthAttribute"))
            {
                this.messages.maxLength = element.errorMessage;

                return Validators.compose([Validators.minLength(element.minimumLength),Validators.maxLength(element.maximumLength)]);
            }
            else if (type.includes("MinLengthAttribute"))
            {
                return Validators.minLength(element.length);
            }
            else if (type.includes("MaxLengthAttribute"))
            {
                return Validators.maxLength(element.length);
            }
        });

        formControl.setValidators(Validators.compose(validators));
    }
}
